import { EMPTY_ARRAY } from 'commons-ui';

import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.coupon,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].updateCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Clone',
				id: 'clone',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.coupon,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].createCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Show Payout Details',
				id: 'conversions',
				isEnabled: () => {
					return true;
				}
			},
			{
				name: 'Deploy on App',
				id: 'deploy',
				isEnabled: (rowData: any) => {
					const { isDisabled } = rowData;
					if (!isDisabled) {
						return false;
					}

					return hasPermission({
						entity: DASHBOARD_RESOURCES.coupon,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].deployCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Remove from App',
				id: 'remove',
				isEnabled: (rowData: any) => {
					const { isDisabled } = rowData;
					if (isDisabled) {
						return false;
					}

					return hasPermission({
						entity: DASHBOARD_RESOURCES.coupon,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].deployCoupon,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],

		bulkActions: EMPTY_ARRAY,

		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.coupon,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.coupon].createCoupon,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
